import { requestConfig } from "../config.js";

/**
 * Получить перечень тарифов у контрагента
 *
 * @param {String} apiKey
 */
export async function apiFetchTariffList(apiKey) {
  const response = await requestConfig.get("/api/v0/master/mobile_connect/get_tariffs/", {
    params: {
      key: apiKey,
    },
  });

  return response.data?.detail;
}
